<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">

    <demo-add :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" @notify="notify" :data="sidebarData" />

    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">


          <!-- ADD NEW -->
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
        
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th>Category</vs-th>
        <vs-th>Pages</vs-th>
        <vs-th>Version</vs-th>
        <vs-th sort-key="category">Imports</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td class="img-container">
              <img :src="img(tr.img)" class="product-img" />
            </vs-td>

            <vs-td>
              <p v-if="tr.name" class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
                <p v-if="tr.category" class="product-category">
                   {{categ(tr.category)}}
                </p>
            </vs-td>

            <vs-td>
                <p v-if="tr.pages" class="product-category">
                   {{pages(tr.pages)}}
                </p>
            </vs-td>


            <vs-td>
              <vs-chip v-if="tr.v" :color="'primary'" class="product-order-status">{{ JSON.parse(tr.v).theme }}</vs-chip>
            </vs-td>

            <vs-td>
              <p v-if="tr.stats" class="product-price">{{ tr.stats }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr)" />
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import demoAdd from './add.vue'
import moduleDemosList from "@/store/demos/moduleDemoList.js"

export default {
  components: {
    demoAdd
  },
  data() {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products() {
      return this.$store.state.demosList.products
    },
    queriedItems() {
        var def = 0;
        if (typeof this.products === 'object'){
            def = this.products.length
        }
      return this.$refs.table ? this.$refs.table.queriedResults.length : def
    }
  },
  methods: { 
    notify(e){
        console.log(e);
        this.$vs.notify(e)
    },   
    img(e){
      // if(e.endsWith(".jpg"))
        return 'https://api.uicore.co/media/small/' + e;
      // else
        // return e;
    },
    categ(cat){
        if (cat == 'null'){
            return 'NONE'   
        }else{
            try {
                JSON.parse(cat);
            } catch (e) {
                return cat;
            }
            if(JSON.parse(cat).length == 0){
              return 'NONE'
            }else{
              return JSON.parse(cat).join(", ")
            }
        }
    },
    pages(cat){
        if (cat == 'null'){
            return 'NONE'   
        }else{
            try {
                JSON.parse(cat);
            } catch (e) {
                return cat;
            }
            if(JSON.parse(cat).length == 0){
              return 'NONE'
            }else{
              return JSON.parse(cat).join(", ")
            }
        }
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData(tr) {
        var id = tr.id
      this.$store.dispatch("demosList/removeItem", id).then(()=> {
          this.$vs.notify({
                title: 'Color',
                text: 'Demo '+tr.name+' was succesfuly deletted!',
                color: 'succes'
            })
      }).catch(err => { console.error(err) })
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    }
  },
  created() {
    if(!moduleDemosList.isRegistered) {
      this.$store.registerModule('demosList', moduleDemosList)
      moduleDemosList.isRegistered = true
    }
    this.$store.dispatch("demosList/fetchDataListItems", this.$store.state.themes.current)
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
